export class FilterManager {
  constructor(
    algoliaManager,
    performSearchAndRenderCallback,
    urlManager,
    grantsTabs = [],
  ) {
    this.algoliaManager = algoliaManager;
    this.performSearchAndRender = performSearchAndRenderCallback;
    this.urlManager = urlManager;
    this.grantsTabs = grantsTabs;
    this.grantAmountSelect = document.getElementById("grant-amount");
    this.grantYearSelect = document.getElementById("grant-year");

    this.initEventListeners();
  }

  initEventListeners() {
    if (this.grantAmountSelect) {
      this.grantAmountSelect.addEventListener("change", async () => {
        const selectedValue = this.grantAmountSelect.value;
        if (selectedValue) {
          this.algoliaManager.setAlgoliaPriceRangeFilter(selectedValue);
        } else {
          this.algoliaManager.setAlgoliaPriceRangeFilter(null);
        }
        await this.performSearchAndRender(
          this.algoliaManager.currentQuery,
          0,
          true,
        );
        // Update URL with the amount filter (store index, not value)
        if (this.urlManager) {
          let { tabSlug, year } = this.urlManager.parseGrantsURL();
          // Default to appropriate hashtag if no tab is specified in URL
          if (!tabSlug) {
            if (this.grantsTabs && this.grantsTabs.length > 1) {
              tabSlug = this.grantsTabs[0].slug;
            } else {
              // Single tab or no tabs - use featured-grants wrapper ID
              tabSlug = "featured-grants";
            }
          }
          const amountIndex =
            this.grantAmountSelect.selectedIndex > 0
              ? this.grantAmountSelect.selectedIndex.toString()
              : "";
          this.urlManager.updateURL(
            tabSlug,
            this.algoliaManager.currentQuery,
            year,
            amountIndex,
            true,
          );
        }
      });
    }

    if (this.grantYearSelect) {
      this.grantYearSelect.addEventListener("change", async () => {
        const selectedValue = this.grantYearSelect.value;
        this.algoliaManager.setAlgoliaYearFilter(selectedValue);
        await this.performSearchAndRender(
          this.algoliaManager.currentQuery,
          0,
          true,
        );
        // Update URL with the year filter
        if (this.urlManager) {
          let { tabSlug } = this.urlManager.parseGrantsURL();
          // Default to appropriate hashtag if no tab is specified in URL
          if (!tabSlug) {
            if (this.grantsTabs && this.grantsTabs.length > 1) {
              tabSlug = this.grantsTabs[0].slug;
            } else {
              // Single tab or no tabs - use featured-grants wrapper ID
              tabSlug = "featured-grants";
            }
          }
          // Get amount as index, not value
          const amountIndex =
            this.grantAmountSelect?.selectedIndex > 0
              ? this.grantAmountSelect.selectedIndex.toString()
              : "";
          this.urlManager.updateURL(
            tabSlug,
            this.algoliaManager.currentQuery,
            selectedValue,
            amountIndex,
            true,
          );
        }
      });
    }
  }

  /**
   * Ensures the amount dropdown shows the default option.
   * @returns {boolean}
   */
  initializeAmountDropdown() {
    if (this.grantAmountSelect && this.grantAmountSelect.options.length > 0) {
      this.grantAmountSelect.selectedIndex = 0; // Select first option (Any Amount)
      return true;
    }
    return false;
  }

  /**
   * Populates the year dropdown with available award years from Algolia facets.
   * @returns {Promise<void>}
   */
  async populateYearDropdown() {
    if (!this.grantYearSelect) return;

    // Clear existing options
    while (this.grantYearSelect.options.length > 0) {
      this.grantYearSelect.remove(0);
    }

    const facets = await this.algoliaManager.getAlgoliaFacets("award_year");
    let years = Object.keys(facets).sort((a, b) => b - a);

    const anyYearOption = document.createElement("option");
    anyYearOption.value = "";
    anyYearOption.textContent = "Year";
    this.grantYearSelect.appendChild(anyYearOption);

    years.forEach((year) => {
      const option = document.createElement("option");
      option.value = year;
      option.textContent = year;
      this.grantYearSelect.appendChild(option);
    });
    this.grantYearSelect.value = "";
  }

  /**
   * Resets all filter UI elements to their default state.
   */
  async resetFiltersUI() {
    this.initializeAmountDropdown();
    if (this.grantYearSelect) {
      this.grantYearSelect.value = "";
    }
    this.algoliaManager.clear(); // Clear Algolia's internal filter states
    await this.performSearchAndRender(
      this.algoliaManager.currentQuery,
      0,
      true,
    ); // Trigger a new search
  }
}
